// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"mq-z","breadcrumbForward":"nq-z","breadcrumbBack":"oq-z","selected":"pq-z"};